<script async setup lang="ts">
const clients = [
  'Практики из бизнес-сообществ',
  'Бизнесмены',
  'Компании',
  'Студенты',
  'Фрилансеры',
  'Специалисты из разных областей',
  'Госслужащие',
  'Для всех, кто желает развиваться 🚀'
];
</script>

<template>
  <section class="clients">
    <div class="clients-title">
      <h1>Для кого этот центр?</h1>
    </div>
    <div class="clients-list">
      <div
        v-for="(client, i) in clients"
        :key="client"
        class="client"
        :class="i == clients.length - 1 ? 'highlight' : ''"
      >
        {{ client }}
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.clients {
  margin-bottom: 80px;

  &-title {
    padding: 80px 0 40px;
  }

  &-list {
    gap: 20px;
    display: flex;
    padding: 60px 0;
    flex-wrap: wrap;
  }

  .client {
    padding: 40px;
    border-radius: 40px;
    background: var(--color-mono-10);

    line-height: 30px;
    font-size: var(--font-size-l);
    color: var(--color-mono-1000);
    font-weight: var(--font-weight-light);
  }

  .highlight {
    background: #153fc8;
    color: var(--color-mono-5);
  }
}
</style>
